/**
 * Attempts to parse a string as JSON, returning the original value when it cannot be parsed.
 * @param {string} string - The string to parse.
 * @return {any|null} - The parsed object, or null if parsing fails.
 */
export const tryParseString = (parsing) => {
  if (typeof parsing === 'string') {
    try {
      return JSON.parse(parsing);
    } catch (error) {
      console.error('Error parsing value:', error);
      return parsing;
    }
  }

  return parsing;
};
